
import {useState} from 'react';
import axios from 'axios';
import {Modal} from '@burna/monster-design-system';
import {useHistory} from 'react-router-dom';
import {APIName} from 'config';
import useUser from 'hooks/useUser';


function Logout({isOpen, onClose}) {
  const user = useUser();
  const history = useHistory();
  const [{error, message}, setStatus] = useState({});
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = () => {
    if (isLoggingOut) {
      return;
    }
    if (user.type === 'web3') {
      setStatus({
        error: false,
        message: 'successfully log out'
      });
      user.setUser(null);
      onClose();
      if (!location.pathname.includes('/download/')) {
        history.push('/');
      }
    } else {
      setIsLoggingOut(true);
      axios.post(`/api/${APIName}/logoutUser`)
        .then(() => {
          setStatus({
            error: false,
            message: 'successfully log out'
          });
          setIsLoggingOut(false);
          user.setUser(null);
          onClose();
          if (!location.pathname.includes('/download/')) {
            history.push('/');
          }
        })
        .catch(() => {
          setStatus({
            error: true,
            message: 'An unexpected error occurred during logout, please try again'
          });
          setIsLoggingOut(false);
        });
    }
  };

  return (
    <Modal
      type="error"
      title="Logout"
      description={isLoggingOut ? 'Logging out...' : 'Are you sure you want to logout?'}
      confirmLabel="Logout"
      closeLabel="Cancel"
      open={isOpen}
      onConfirm={handleLogout}
      onClose={onClose}
    />
  );
}

export default Logout;
